import Image from "next/image";

export function NeuroscaleLogo() {
  return (
    <Image
      src="/logos/neuroscale.svg"
      alt="Neuroscale AI"
      width={192}
      height={28}
      className="auth-neuroscale-logo h-7 w-48"
    />
  );
}
